"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer() {
  return _react2.default.createElement(
    "footer",
    { className: "Footer" },
    _react2.default.createElement(
      "p",
      { className: "poweredBy" },
      "Propuls\xE9 par ",
      _react2.default.createElement(
        "a",
        { href: "http://pro.caligram.com", target: "_blank" },
        "Caligram Pro"
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.js
// module id = 1167
// module chunks = 0